<template>
  <div>
    <!-- <div>
      <h2>Search and add a pin</h2>
      <label>
        <gmap-autocomplete @place_changed="setPlace"></gmap-autocomplete>
        <button @click="addMarker">Add</button>
      </label>
      <br />
    </div>
    <br />-->
    <gmap-map
      @click="addNewMarker"
      @zoom_changed="zoomChanged"
      :options="options"
      :center="center"
      :zoom="z"
      style="width:100%;  height: 400px;"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :clickable="true"
        :draggable="true"
        @click="center=m.position"
        @dragend="updateCenter"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  props: {
    params: Object,
    zoom: Number
  },
  data() {
    return {
      center: { lat: this.params.lat, lng: this.params.lng },
      markers: [{ position: { lat: this.params.lat, lng: this.params.lng } }],
      places: [],
      currentPlace: null,
      options: {
        disableDoubleClickZoom: true
      },
      z: this.zoom
    };
  },
  async created() {},
  mounted() {
    this.geolocate();
  },
  watch: {
    center(value) {
      this.$emit("update:params", {
        lat: value.lat,
        lng: value.lng,
        z: this.zoom
      });
    }
  },
  methods: {
    // nhận địa điểm thông qua autocomplete component
    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    updateCenter(location) {
      this.center = { lat: location.latLng.lat(), lng: location.latLng.lng() };
      this.$emit("update:params", {
        lat: this.center.lat,
        lng: this.center.lng
      });
    },
    updatelatLng(ob) {
      this.markers = [{ position: { lat: +ob.lat, lng: +ob.lng } }];
      this.center = { lat: +ob.lat, lng: +ob.lng };
      this.z = +ob.zoom;
    },
    addNewMarker(location) {
      // console.log("add");
    },
    zoomChanged(value) {
      this.$emit("update:zoom", value);
    }
  }
};
</script>